import { render, staticRenderFns } from "./risk-warn.vue?vue&type=template&id=406a0f5d"
import script from "./risk-warn.vue?vue&type=script&lang=js"
export * from "./risk-warn.vue?vue&type=script&lang=js"
import style0 from "./risk-warn.vue?vue&type=style&index=0&id=406a0f5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports